import React, { useState } from "react";
import "../../assets/styles/form-styles.css";
import { BaseInput, BaseButton, BaseTextarea } from "../../components/ui";

const ContratoGenerar = () => {
  const [formData, setFormData] = useState({
    inquilino_id: "",
    espacio_id: "",
    propietario_id: "",
    fecha_inicio: "",
    fecha_fin: "",
    monto_alquiler: "",
    monto_garantia: "",
    descripcion: "",
    documento: null,
  });

  const [submitting, setSubmitting] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      documento: e.target.files?.[0] || null,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value != null) formDataToSend.append(key, value);
    });

    try {
      setSubmitting(true);
      const response = await fetch("URL_DE_TU_API/contratos", {
        method: "POST",
        body: formDataToSend,
      });

      if (response.ok) {
        alert("Contrato registrado exitosamente!");
        setFormData({
          inquilino_id: "",
          espacio_id: "",
          propietario_id: "",
          fecha_inicio: "",
          fecha_fin: "",
          monto_alquiler: "",
          monto_garantia: "",
          descripcion: "",
          documento: null,
        });
      } else {
        throw new Error("Error al registrar el contrato");
      }
    } catch (error) {
      console.error("Error al registrar contrato:", error);
      alert("Error al registrar el contrato");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="form-container">
      <h2 className="form-title">Registrar Contrato</h2>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form-row">
          <BaseInput
            label="Inquilino ID"
            name="inquilino_id"
            id="inquilino_id"
            required
            restrict="number"
            value={formData.inquilino_id}
            onChange={handleChange}
          />
          <BaseInput
            label="Espacio ID"
            name="espacio_id"
            id="espacio_id"
            required
            restrict="number"
            value={formData.espacio_id}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <BaseInput
            label="Propietario ID"
            name="propietario_id"
            id="propietario_id"
            required
            restrict="number"
            value={formData.propietario_id}
            onChange={handleChange}
          />
          <BaseInput
            label="Fecha de Inicio"
            name="fecha_inicio"
            id="fecha_inicio"
            type="date"
            required
            value={formData.fecha_inicio}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <BaseInput
            label="Fecha de Fin"
            name="fecha_fin"
            id="fecha_fin"
            type="date"
            required
            min={formData.fecha_inicio || undefined}
            value={formData.fecha_fin}
            onChange={handleChange}
          />
          <BaseInput
            label="Monto de Alquiler"
            name="monto_alquiler"
            id="monto_alquiler"
            type="number"
            required
            restrict="decimal"
            min="0"
            step="0.01"
            value={formData.monto_alquiler}
            onChange={handleChange}
          />
        </div>

        <div className="form-row">
          <BaseInput
            label="Monto de Garantía"
            name="monto_garantia"
            id="monto_garantia"
            type="number"
            required
            restrict="decimal"
            min="0"
            step="0.01"
            value={formData.monto_garantia}
            onChange={handleChange}
          />
          <BaseInput
            label="Subir Documento (PDF)"
            name="documento"
            id="documento"
            type="file"
            accept=".pdf"
            required
            onChange={handleFileChange}
          />
        </div>

        <BaseTextarea
          wrapperClassName="form-row-full"
          label="Descripción"
          name="descripcion"
          id="descripcion"
          required
          rows={4}
          value={formData.descripcion}
          onChange={handleChange}
        />

        <BaseButton type="submit" variant="primary" loading={submitting} fullWidth>
          Registrar Contrato
        </BaseButton>
      </form>
    </div>
  );
};

export default ContratoGenerar;
